import "./index.scss";
import { useCheckoutContext } from "context/checkout-context";
import { CheckoutPaymentMethod } from "..";
import { renderCardType } from "./utils/renderCardType";

export const CheckoutPaymentSelector = ({ toggleForm }) => {
  const { openDropDown, setPayment, isDdOpen, selectedPayment, paymentData } =
    useCheckoutContext();

  const paymentMethods = paymentData?.data;
  const selectedPaymentMethod = paymentMethods?.find(
    ({ uuid }) => uuid === selectedPayment
  );

  const handleDropDownChange = (selectedId) => {
    openDropDown(false);
    setPayment(selectedId);
  };

  const handleDropDownClick = () => {
    openDropDown(!isDdOpen);
  };

  return (
    <div className="checkout-payment-selector">
      <p className="saved-card">
        Saved Credit Card: <abbr title="required">*</abbr>
      </p>
      <div className={`selector-dropdown${isDdOpen ? " open" : ""}`}>
        {selectedPaymentMethod && (
          <CheckoutPaymentMethod
            key={selectedPaymentMethod.uuid}
            networkImg={renderCardType(selectedPaymentMethod.network)}
            onClick={handleDropDownClick}
            isOpen={isDdOpen}
            isSelector
            {...selectedPaymentMethod}
          />
        )}
        <div className="payment-methods-list">
          {paymentMethods?.map((paymentMethod) => (
            <CheckoutPaymentMethod
              key={paymentMethod.uuid}
              networkImg={renderCardType(paymentMethod.network)}
              onClick={() => handleDropDownChange(paymentMethod.uuid)}
              isOpen={isDdOpen}
              isDdSelected={selectedPaymentMethod.uuid === paymentMethod.uuid}
              {...paymentMethod}
            />
          ))}
        </div>
      </div>
      <figure className="payment-networks" />
      <button onClick={toggleForm} className="add-cc-button">
        Add new Credit Card
      </button>
    </div>
  );
};
